var _slicedToArray = require("D:\\Projects\\SoLiDRDP\\solid-rdm\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/slicedToArray");

var _regeneratorRuntime = require("D:\\Projects\\SoLiDRDP\\solid-rdm\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

var _asyncToGenerator = require("D:\\Projects\\SoLiDRDP\\solid-rdm\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/asyncToGenerator");

var _classCallCheck = require("D:\\Projects\\SoLiDRDP\\solid-rdm\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("D:\\Projects\\SoLiDRDP\\solid-rdm\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var concatStream = require('concat-stream');

var contentTypeLookup = require('mime-types').contentType;

var url = require('url');

var Readable = require('stream').Readable;

var path = require("path");

var fs = require("fs-extra");

var SolidFileStorage =
/*#__PURE__*/
function () {
  "use strict";

  function SolidFileStorage() {
    _classCallCheck(this, SolidFileStorage);

    this.prefix = "file";
    this.name = "solid-rest-file-storage-1.0.0";
  }

  _createClass(SolidFileStorage, [{
    key: "_makeStream",
    value: function _makeStream(text) {
      var s = new Readable();
      s.push(text);
      s.push(null);
      return s;
    }
  }, {
    key: "text",
    value: function () {
      var _text = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(stream) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", new Promise(function (resolve, reject) {
                  stream = stream || "";
                  if (typeof stream === "string") return resolve(stream);
                  stream.pipe(concatStream({
                    encoding: 'string'
                  }, resolve())).catch(function (e) {
                    console.log(e);
                    reject();
                  });
                  stream.on('error', reject());
                }));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function text(_x) {
        return _text.apply(this, arguments);
      }

      return text;
    }()
  }, {
    key: "json",
    value: function () {
      var _json = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(stream) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", text(stream).then(function (text) {
                  return JSON.parse(text);
                }));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function json(_x2) {
        return _json.apply(this, arguments);
      }

      return json;
    }()
  }, {
    key: "getObjectType",
    value: function () {
      var _getObjectType = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(fn, options) {
        var stat, type;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                try {
                  stat = fs.lstatSync(fn);
                } catch (err) {}

                type = stat && stat.isDirectory() ? "Container" : "Resource";
                if (!stat && fn.endsWith('/')) type = "Container";
                return _context3.abrupt("return", Promise.resolve([type, stat]));

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function getObjectType(_x3, _x4) {
        return _getObjectType.apply(this, arguments);
      }

      return getObjectType;
    }()
  }, {
    key: "getResource",
    value: function () {
      var _getResource = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(pathname, options, objectType) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", new Promise(function (resolve) {
                  var fn = pathname.replace(/.*\//, '');
                  var success = "";

                  try {
                    fs.createReadStream(pathname).on("data", function (chunk) {
                      success = success + chunk;
                    }).on("error", function (err) {
                      console.log(err);
                    }).on("end", function () {
                      return resolve([200, success]);
                    });
                  } catch (e) {}
                }));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function getResource(_x5, _x6, _x7) {
        return _getResource.apply(this, arguments);
      }

      return getResource;
    }()
  }, {
    key: "putResource",
    value: function () {
      var _putResource = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5(pathname, options) {
        var _this = this;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", new Promise(function (resolve) {
                  options.body = _this._makeStream(options.body);
                  options.body.pipe(fs.createWriteStream(pathname)).on('finish', function () {
                    resolve([201]);
                  }).on('error', function (err) {
                    if (options.method === "PUT" && options.objectType === "Container") resolve([405]);
                    resolve([500]);
                  });
                }));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function putResource(_x8, _x9) {
        return _putResource.apply(this, arguments);
      }

      return putResource;
    }()
  }, {
    key: "deleteResource",
    value: function () {
      var _deleteResource = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6(fn) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt("return", new Promise(function (resolve) {
                  fs.unlink(fn, function (err) {
                    if (err) resolve([409]);else resolve([200]);
                  });
                }));

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      function deleteResource(_x10) {
        return _deleteResource.apply(this, arguments);
      }

      return deleteResource;
    }()
  }, {
    key: "deleteContainer",
    value: function deleteContainer(fn) {
      return new Promise(function (resolve) {
        fs.rmdir(fn, function (err) {
          if (err) {
            resolve([409]);
          } else {
            resolve([200]);
          }
        });
      });
    }
  }, {
    key: "postContainer",
    value: function postContainer(fn, options) {
      fn = fn.replace(/\/$/, '');
      return new Promise(function (resolve) {
        if (fs.existsSync(fn)) {
          return resolve([201]);
        }

        fs.mkdirp(fn, {}, function (err) {
          if (err) {
            return resolve([500]);
          } else {
            return resolve([201]);
          }
        });
      });
    }
  }, {
    key: "makeContainers",
    value: function () {
      var _makeContainers = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7(pathname, options) {
        var filename, reg, foldername, _ref, _ref2, t, exists;

        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                filename = path.basename(pathname);
                reg = new RegExp(filename + "\$");
                foldername = pathname.replace(reg, '');
                _context7.next = 5;
                return this.getObjectType(foldername);

              case 5:
                _ref = _context7.sent;
                _ref2 = _slicedToArray(_ref, 2);
                t = _ref2[0];
                exists = _ref2[1];

                if (!exists) {
                  _context7.next = 11;
                  break;
                }

                return _context7.abrupt("return", Promise.resolve(200));

              case 11:
                foldername = foldername.replace(/\/$/, '');
                fs.mkdirpSync(foldername, {}, function (err) {
                  if (err) return Promise.resolve(err);else return Promise.resolve(201);
                });

              case 13:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function makeContainers(_x11, _x12) {
        return _makeContainers.apply(this, arguments);
      }

      return makeContainers;
    }()
  }, {
    key: "getContainer",
    value: function () {
      var _getContainer = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8(pathname, options) {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                return _context8.abrupt("return", fs.readdirSync(pathname));

              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));

      function getContainer(_x13, _x14) {
        return _getContainer.apply(this, arguments);
      }

      return getContainer;
    }()
  }]);

  return SolidFileStorage;
}();

module.exports = SolidFileStorage;